import { Fragment, useContext } from 'react';
import { CruiseContext } from '../../../contexts/CruiseContext';
import { Spinner, Card } from 'react-bootstrap';
import UpdateCruiseModal from './UpdateCruiseModal';
import ShowCruiseModal from './ShowCruiseModal';
import DeleteModal from '../DeleteModal';
import { ROLES, PERMISSIONS } from '../../../contexts/constants';
import { AuthContext } from '../../../contexts/AuthContext';
import { getTable, getTableOptions, getDefaultSort } from '../../../utils/table';
import { useTranslation } from 'react-i18next';

const ListCruise = () => {
	const { t } = useTranslation();
	// Context
	const {
		authState: { user },
	} = useContext(AuthContext);
	const {
		cruiseState: { cruise, cruises, cruisesLoading },
		findCruise,
		deleteCruise,
		setShowUpdateCruiseModal,
		setShowCruiseModal,
		setShowToast,
	} = useContext(CruiseContext);

	const chooseCruise = (cruiseId) => {
		findCruise(cruiseId);
		setShowUpdateCruiseModal(true);
	};

	const showCruise = (cruiseId) => {
		findCruise(cruiseId);
		setShowCruiseModal(true);
	};

	if (cruisesLoading) {
		return (
			<div className='spinner-container'>
				<Spinner animation='border' variant='info'></Spinner>
			</div>
		);
	}

	if (cruises === null || cruises.length === 0) {
		return (
			<Fragment>
				<Card className='text-center mx-5 my-5'>
					<Card.Header as='h1'>Hi {user.name}</Card.Header>
					<Card.Body>
						<Card.Title>{t('Welcome to Cruise Manage')}</Card.Title>
						<Card.Text>{t('Click the Add Cruise button to create your first Cruise')}</Card.Text>
					</Card.Body>
				</Card>
			</Fragment>
		);
	}

	const cruiseTable = getListCruiseTable(cruises, user, chooseCruise, deleteCruise, setShowToast, t);
	return (
		<Fragment>
			{cruiseTable}
			{cruise !== null && <UpdateCruiseModal />}
			{cruise !== null && <ShowCruiseModal />}
		</Fragment>
	);
};

const getTableData = (cruises, user, chooseCruise, deleteCruise, setShowToast, t) => {
	return cruises.map((cruise, index) => {
		return {
			index: index + 1,
			id: cruise.id,
			name: cruise.name,
			max_customer: cruise.max_customer,
			action: (
				<div className='row'>
					<div className='col-sm'>
						{user.Roles.includes(ROLES.SUPPER_ADMINISTRATOR) || user.Permissions.includes(PERMISSIONS.UPDATE_CRUISE) ? (
							<button className='btn btn-success btn-with-icon btn-block' onClick={chooseCruise.bind(this, cruise.id)}>
								<i className='fe fe-edit'></i> {t('Edit')}
							</button>
						) : null}
					</div>
					<div className='col-sm'>
						{user.Roles.includes(ROLES.SUPPER_ADMINISTRATOR) || user.Permissions.includes(PERMISSIONS.DELETE_CRUISE) ? (
							<DeleteModal idProps={cruise.id} deleteFunc={deleteCruise} setShowToast={setShowToast} nameProps={cruise.name} />
						) : null}
					</div>
				</div>
			),
		};
	});
};

const getColumns = (t) => {
	return [
		{
			dataField: 'index',
			text: 'STT',
			sort: true,
		},
		{
			dataField: 'id',
			text: 'ID',
			sort: true,
		},
		{
			dataField: 'name',
			text: t('Name'),
			sort: true,
			classes: 'td-left'
		},
		{
			dataField: 'max_customer',
			text: t('Max Customers'),
			sort: true,
		},
		{
			dataField: 'action',
			text: '',
		},
	];
};

const getListCruiseTable = (cruises, user, chooseCruise, deleteCruise, setShowToast, t) => {
	if (!cruises || cruises.length === 0) return null;
	const tableData = getTableData(cruises, user, chooseCruise, deleteCruise, setShowToast, t);
	const columns = getColumns(t);
	const defaultSorted = getDefaultSort();
	const options = getTableOptions(tableData.length, t);

	return getTable(tableData, columns, defaultSorted, options);
};

export default ListCruise;
